import 'whatwg-fetch';
import * as settings from '../settings';

const dataHost = settings.CONTENT_URL;
const apiHost = settings.API_URL;

export const getQueryStringParams = query => {
  return query
    ? (/^[?#]/.test(query) ? query.slice(1) : query)
        .split('&')
        .reduce((params, param) => {
          let [key, value] = param.split('=');
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, ' '))
            : '';
          return params;
        }, {})
    : {};
};

const getListIDs = pageType => {
  switch (pageType) {
    case 'videoPermalink':
      return ['series_videos', 'all_series'];
      break;
    case 'gamePermalink':
    case 'bookPermalink':
      return ['related_content'];
    case 'gamesLanding':
      return ['featured_content_on_games', 'all_games'];
    case 'videosLanding':
      return ['featured_content_on_videos', 'all_series'];
    case 'booksLanding':
      return ['featured_content_on_books', 'all_books'];
    case 'mathZone':
      return ['featured_content_on_math_zone', 'all_math_content'];
    case 'gradeLanding':
      return ['featured_content_on_grade', 'all_for_grade'];
    case 'homepage':
      return [
        'popular_games',
        'popular_videos',
        'popular_books',
        'new_games',
        'new_videos',
        'new_books',
      ];
    case 'harryMoonLanding':
      return ['harry_moon_books', 'harry_moon_supplemental_materials'];
    case 'monsterMeLanding':
      return ['monster_me_books'];
    default:
      return [];
  }
};

const getHeroID = (pageType, qs) => {
  switch (pageType) {
    case 'gamesLanding':
      return 'games_hero';
    case 'videosLanding':
      return 'videos_hero';
    case 'booksLanding':
      return 'books_hero';
    case 'mathZone':
      return 'math_zone_hero';
    case 'gradeLanding':
      return `grade_${qs.grade}_hero`;
    case 'homepage':
      return 'homepage_hero';
    case 'harryMoonLanding':
      return 'harry_moon_hero';
    default:
      return '';
  }
};

const adEventBase = eventId => {
  switch (eventId) {
    case 'PLAYGROUND_AD_VIEWED':
      return 'HubAdImpressions';
    case 'PLAYGROUND_AD_CHARACTER_CLICKED':
      return 'SponsorClickedFromCharacter';
    case 'PLAYGROUND_AD_CLICKED':
      return 'SponsorClickedFromBrain';
    case 'SPONSORED_CONTENT_VIEWED':
      return 'ContentImpressions';
    case 'AD_CLICKED':
      return 'Clicked';
    case 'AD_VIEWED':
      return 'Viewed';
    case 'BACKGROUND_SKIN_VIEWED':
      return 'BackgroundSkinViewed';
    case 'BACKGROUND_SKIN_CLICKED':
      return 'BackgroundSkinCLICKED';
    default:
      return null;
  }
};

const adEventTypes = (eventId, page, elementId) => {
  const base = adEventBase(eventId);
  if (page === 'playground') return base;

  const actionSource = elementId ? `From${settings.capitalize(elementId)}` : '';
  return `${settings.capitalize(page)}${base}${actionSource}`;
};

export const createTrackingUrl = (page, eventId, campaign, elementId) => {
  const rand = Math.floor(Math.random() * 1000000);
  return `${settings.AD_TRACK_URL}?event=${adEventTypes(
    eventId,
    page,
    elementId
  )}&campaign=${campaign.id}&brain=kidsandparents&randomNumber=${rand}`;
};

export const trackAd = url => {
  return fetch(url).then(response => response);
};

export const fetchBookData = url => {
  return fetch(`${url}book-data.json`).then(response => response.json());
};

export const qsToString = querystring => {
  let qs = [];
  for (const q in querystring) {
    qs.push(`${q}=${querystring[q]}`);
  }
  return qs.join('&');
};

export const fetchMediaLists = (pageType, querystring) => {
  const endpoint = '/media-lists?';
  querystring['hero-id'] = getHeroID(pageType, querystring);
  if (!querystring['landing-path']) {
    querystring['list-ids'] = getListIDs(pageType).join(',');
  }
  const url = `${apiHost}${endpoint}${qsToString(querystring)}`;
  return fetch(url).then(response => response.json());
};

export const fetchMedia = (id, querystring) => {
  const endpoint = '/media?slug=';
  return fetch(
    `${apiHost}${endpoint}${id}&${qsToString(querystring)}`
  ).then(response => response.json());
};

export const fetchTinybopEmbeddedGame = () => {
  const endpoint = '/tinybop-embedded-game';
  return fetch(`${apiHost}${endpoint}`).then(response => response.json());
};
